import { connect } from 'react-redux';
import * as actions from './FinancialPlanWrapperActions';
import FinancialPlanWrapperView from './FinancialPlanWrapperView';
import { setGoalId } from '../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownActions';

const mapStateToProps = (state, ownProps) => {
  const subdivision = state.FinancialPlan[ownProps.clientId];
  return {
    fpId: subdivision ? subdivision.fpId : undefined,
    ...ownProps,
    children: ownProps.children,
    clientId: ownProps.clientId,
    isPrint: ownProps.isPrint,
    printDone: ownProps.printDone,
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data(clientId) {
    dispatch(actions.fetch_data(clientId));
  },
  setGoal: (goalId, clientId) => {
    dispatch(setGoalId(goalId, clientId));
  },
});

const FinancialPlanWrapper = connect(mapStateToProps, mapDispatchToProps)(FinancialPlanWrapperView);

export default FinancialPlanWrapper;
